import type { TestoStampaLetto } from '../../api/testiStampa';

/*  LE CLAUSOLE CHE SI TROVANO GIA' SPUNTATE, dato il lavoro di cui parla l'offerta.

    «L'amministratore spunta i predefiniti per categoria e poi il redattore se li trova
    gia' spuntati, e spunta o toglie al massimo altri che vuole o non vuole» (Andrea,
    08/10/2026).

    Una clausola predefinita e' predefinita PER LA SUA CATEGORIA: le esclusioni
    elettriche non vanno spuntate da sole su un'offerta meccanica, e viceversa. Quelle
    SENZA categoria entrano sempre — la garanzia, la validita' dell'offerta — perche'
    valgono per tutti i lavori: e' lo stesso significato che hanno nel filtro.

    Senza un lavoro deciso restano le sole senza categoria, che e' il comportamento di
    prima su un'offerta che nessuno ha ancora detto di che impianto sia.

    I TITOLI NON CI SONO MAI: non si spuntano, compaiono in stampa se sotto hanno
    qualcosa di scelto. Il dominio rifiuta un titolo predefinito, quindi qui non
    arrivano — ma il filtro sul gruppo resta, perche' una lettera d'accompagnamento
    predefinita non e' una condizione e non va fra le spunte.  */
export function predefiniteDelLavoro(
  testi: readonly TestoStampaLetto[],
  lavoro: string,
): string[] {
  return testi
    .filter(
      (t) =>
        t.gruppo === 'Condizioni' &&
        t.predefinito &&
        (t.categoria === null || t.categoria === '' || t.categoria === lavoro),
    )
    .map((t) => t.id);
}
